const ACCESS_TOKEN_KEY = 'access_token';

export function getToken() {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setTokenSessionStorage(token: string) {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
}
